import React from 'react';
import Content from '../dashboard/Content';
import Dialog from '../../toolkit/dialog';
import UpdateFile from './UpdateFile';
import CreateFile from './CreateFile';
import FirmwareBox from './FirmwareBox';
import FirmwareFile from './FirmwareFile';
import DevelopmentDevices from './DevelopmentDevices';
import AddDeviceModeDialog from './AddDeviceModeDialog';
import DeleteFirmwareDialog from './DeleteFirmwareDialog';
import { RouteComponentProps } from 'react-router';
import { ExportData } from './ActionFile';
import { Input } from '../widgets/beauty';
import { fileTypeByName } from '../../utils/firmware';
import FirmwareRenameDialog from './FirmwareRenameDialog';
import updateService from '../../services/update-service';

export interface RouteParams {
  firmwareId: string;
}

export interface FileSchema {
  id: string;
  name: string;
  type: string;
  version: number | string;
  link: string;
}

export interface UpdateFirmwareProps extends RouteComponentProps<RouteParams> {
}

export interface UpdateFirmwareState {
  type: string;
  selected: string;
  mode: 'create' | 'update';
  files: FileSchema[];
  format: string;
  formatVersion: string;
  versions: string;
  enable: boolean | undefined;
  freez: 'create' | 'update' | 'delete';
  developmentRadio: string;
  developmentDevices: string[];
  statusText: string;
  statusType: string;
  downloadLink: string;
}

class UpdateFirmware extends React.Component<UpdateFirmwareProps, UpdateFirmwareState> {

  state: UpdateFirmwareState = {
    type: '',
    selected: null,
    mode: 'update',
    freez: null,
    format: '',
    formatVersion: '',
    versions: '',
    enable: null,
    files: [],
    developmentRadio: '',
    statusText: '',
    statusType: 'warning',
    developmentDevices: [],
    downloadLink: null
  };

  render() {
    const state = this.state;
    const title = (
      <>
        بروزرسانی فرمور /
        <span className="en-font mr-2">{state.type}</span>
        <button className="ant-btn mr-auto" onClick={this.handleChangeVersion}>تغییر نام ورژن</button>
      </>
    );
    return (
      <Content title={title}>
        <div className="container-fluid h-100">
          <div className="row">
            <div className="col-xxl-6 col-lg-7 col-12" style={{ minHeight: '550px' }}>
              <FirmwareBox title="لیست فایل ها" style={{ height: '', minHeight: '400px' }}>
                <div className="row files-list">
                  {state.files.map(file => (
                    <FirmwareFile
                      key={file.name}
                      name={file.name}
                      type={file.type as any}
                      checked={file.name === state.selected}
                      onClick={this.onFileClick}
                    />
                  ))}
                </div>
                <div className="d-flex mt-auto mb-2 ltr">
                  <button className="btn btn-success flex-center col-md-4 col-6 mx-auto rtl" onClick={this.onCreateClick}>
                    <i className="far fa-plus"></i>
                    <span className="mr-1">فایل جدید</span>
                  </button>
                </div>
              </FirmwareBox>
            </div>
            <div className="col-xxl-6 col-lg-5 mt-lg-0 mt-3">
              <FirmwareBox title="ویژگی ها">
                {(state.mode === 'create') ? <CreateFile freez={state.freez} onCreate={this.handleCreate} /> :
                  (state.selected ?
                    <UpdateFile
                      freez={state.freez}
                      version={this.getSelectedVersion()}
                      filename={state.selected}
                      onUpdate={this.handleUpdate}
                      onDelete={this.handleDelete}
                      downloadLink={this.state.downloadLink}
                    /> :
                    <div className="col-xxl-10 col-lg-12 col-12 mx-auto">
                      <div className="alert alert-primary text" style={{ lineHeight: 2 }}>
                        برای ویرایش یا حذف فایل از سمت راست یک فایل را انتخاب کرده و برای ایجاد فایل روی دکمه "فایل جدید" کلیک کنید
                      </div>
                    </div>
                  )
                }
              </FirmwareBox>
            </div>
            <div className="col-xxl-6 col-lg-7 col-12 mt-3">
              <FirmwareBox title="اطلاعات فنی">
                <div className="row ltr text-left">
                  <div className="col-12 mb-3">
                    <label className="form-label en-font">Format</label>
                    <input type="text" className="form-control" readOnly value={state.format} />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label en-font">Versions</label>
                    <input type="text" className="form-control" readOnly value={state.versions} />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label en-font">FormatVersion</label>
                    <input type="text" className="form-control" readOnly value={state.formatVersion} />
                  </div>
                </div>
              </FirmwareBox>
            </div>
            <div className="col-xxl-6 col-lg-5 col-12 mt-3">
              <FirmwareBox title="وضعیت بروزرسانی">
                <div className="row ltr text-left h-100">
                  <div className="col-12">
                    <Input.Checkbox
                      checked={this.state.enable}
                      id="update-enable"
                      text="Enable"
                      value="true"
                      onChange={this.onCheckboxChange}
                      labelAttrs={{ className: 'form-label en-font' }} />

                    <div className="ml-3">
                      <Input.RadioButton
                        text="Global"
                        id="radio-global"
                        name="is-development"
                        value="global"
                        checked={state.developmentRadio === 'global'}
                        labelAttrs={{ className: 'form-label en-font' }}
                        onChange={this.onRadioChange}
                        disabled={!state.enable}
                      />
                      <Input.RadioButton
                        text="Development"
                        id="is-development"
                        name="radio-development"
                        value="development"
                        checked={state.developmentRadio === 'development'}
                        labelAttrs={{ className: 'form-label en-font' }}
                        onChange={this.onRadioChange}
                        disabled={!state.enable}
                      />
                    </div>
                    <div className={'text-' + state.statusType + ' text-center mt-3 mb-2'}>
                      {state.statusText}
                    </div>
                  </div>
                  <hr style={{ width: '100%' }} />
                  <div className="col-12">
                    <DevelopmentDevices
                      items={this.state.developmentDevices}
                      addClickHandler={this.addDevelopDevice}
                      removeClickHandler={this.deleteDevelopDevice}
                    />
                  </div>
                </div>
              </FirmwareBox>
            </div>

          </div>
        </div>
      </Content>
    );
  }

  public componentDidMount = async () => {
    const { getFirmwareId } = this;
    try {
      const response = await updateService.findById(getFirmwareId());
      this.updateStateByResponse(response);
    }
    catch (err) {
      console.error(err);
    }
  }

  private handleChangeVersion = () => {
    const { firmwareId } = this.props.match.params;
    const dialog = new Dialog({
      rtl: true,
      title: 'نام ورژن را بنویسید',
      size: 'small',
      message: FirmwareRenameDialog,
      onClose: () => { this.componentDidMount() }
    });
    dialog.show({ type: this.state.type, id: firmwareId });
  }

  private onRadioChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.setState({
      developmentRadio: value,
      statusText: 'در حال بروزرسانی',
      statusType: 'warning'
    }, async () => {
      try {
        await updateService.changeDevelopMode(this.getFirmwareId(), value !== 'global');
        await this.componentDidMount();
      }
      catch (err) {
        this.setState({
          statusType: 'danger',
          statusText: 'خطا در ثبت اطلاعات'
        });
      }
    });

  }

  private onCheckboxChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    this.setState({
      enable: checked,
      statusText: 'در حال بروزرسانی',
      statusType: 'warning'
    }, async () => {
      try {
        await updateService.changeEnable(this.getFirmwareId(), checked);
        await this.componentDidMount();
      }
      catch (err) {
        console.error(err);
        this.setState({
          enable: !checked,
          statusType: 'danger',
          statusText: 'خطا در ثبت اطلاعات'
        });
      }
    });
  }

  private onFileClick = (file: any) => {
    const found = this.state.files.find(f => f.name === file.name) as any;
    this.setState({ selected: file.name, mode: 'update', downloadLink: found.link });
  }

  private onCreateClick = () => {
    this.setState({ selected: null, mode: 'create' });
  }

  private handleCreate = async (data: ExportData) => {
    this.handleCreateOrUpdate('create', data);
  }

  private handleUpdate = async (data: ExportData) => {
    this.handleCreateOrUpdate('update', data);
  }

  private handleCreateOrUpdate = async (mode: string, data: ExportData) => {
    this.setState({ freez: mode as any });
    const form = new FormData();
    form.append('file', data.file);
    form.append('name', data.file.name);
    if (data.oldName) {
      form.append('oldName', data.oldName);
    }
    try {
      await updateService.addFile(this.getFirmwareId(), form);
      await this.componentDidMount();
      this.resetMode();
    }
    catch (e) {
      console.log('ERRROR', e);
    }
  }

  private handleDelete = async () => {
    const { getFirmwareId } = this;
    try {
      new Dialog({
        showTitle: false,
        rtl: true,
        size: 'small',
        message: DeleteFirmwareDialog,
        onResolve: async (remove: boolean) => {
          if (remove) {
            this.setState({ freez: 'delete' });
            await updateService.removeFile(getFirmwareId(), this.state.selected);
            await this.componentDidMount();
            this.resetMode();
          }
        }
      }).show();
    }
    catch (e) {
      console.error(e);
    }
  }

  private addDevelopDevice = () => {
    const dialog = new Dialog({
      rtl: true,
      size: 'small',
      message: AddDeviceModeDialog,
      onResolve: async (deviceId: string) => {
        try {
          await updateService.addDevelopDevice(this.getFirmwareId(), deviceId);
          this.componentDidMount();
          dialog.close();
        }
        catch (e) {
          if (e.response.status === 409) {
            alert('این ورژن قبلا ثبت شده است');
          }
          if (e.response.status === 404) {
            alert('ورژنی با این شناسه یافت نشد');
          }
          console.error(e);
        }
      }
    });
    dialog.show();
  }

  private deleteDevelopDevice = async (event: React.MouseEvent) => {
    const element = event.target as HTMLElement;
    const serial = element.getAttribute('data-serial');
    const result = window.confirm('آیا میخواهید این مورد را حذف کنید؟');
    if (!result) {
      return;
    }
    try {
      await updateService.deleteDevelopDevice(this.getFirmwareId(), serial);
      this.componentDidMount();
    }
    catch (e) {
      if (e.response.status === 404) {
        alert('ورژنی با این شناسه یافت نشد');
      }
      console.error(e);
    }
  }

  private updateStateByResponse = (response: any) => {
    const type = response.type;
    let files = response.files ?? [];
    const result: FileSchema[] = [];
    for (const file of files) {
      result.push({
        id: file._id,
        name: file.name,
        version: file.version,
        type: fileTypeByName(file.name),
        link: file.link
      });
    }
    const { format, versions, formatVersion } = response.format;
    const developmentRadio = response.developMode ? 'development' : 'global';
    this.setState({
      type,
      files: result,
      versions, format,
      formatVersion,
      enable: response.enable,
      developmentRadio,
      statusText: this.getFormattedSatus(response.enable, developmentRadio),
      statusType: 'primary',
      developmentDevices: response.developDevices
    });
  }

  private resetMode = () => {
    return this.setState({ mode: 'update', selected: null, freez: null });
  }

  private getFirmwareId = () => {
    return this.props.match.params.firmwareId;
  }

  private getSelectedVersion = () => {
    const { files, selected } = this.state;
    const found = files.find(f => f.name === selected);
    if (found) {
      return found.version as string;
    }
    return null;
  }

  private getFormattedSatus = (enable: any, developmentRadio: any) => {
    let result = 'وضعیت ثبت شده: ';
    result += enable ? 'فعال - ' : 'غیرفعال - ';
    result += developmentRadio === 'global' ? 'گلوبال' : 'دولوپمنت';
    return result;
  }

}

export default UpdateFirmware;
